<app-dashboard-option [categories]="['CELLS']" [label]="'DRAGGABLE'">
  <div app-dashboard-option-content>
    <app-check [color]="color" [value]="false" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-dashboard-option>